import Joi from "joi";
import errorMessages from "./errorMessages.json";

export default Joi.object({
  type: Joi.valid("epub", "print")
})
  .unknown()
  .messages(errorMessages);
